import { useTranslation } from 'react-i18next';
import { Map, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';

// interface MapPreviewProps {
//     config?: any;
// }

export const MapPreview = () => {
    const { t } = useTranslation();

    // Placeholder for interactive map integration (e.g., Leaflet or Google Maps static)

    return (
        <section className="bg-slate-100 py-12 relative overflow-hidden group">
            {/* Background Map Image (Placeholder) */}
            <div className="absolute inset-0 opacity-40 grayscale group-hover:grayscale-0 transition-all duration-700">
                <img
                    src="https://upload.wikimedia.org/wikipedia/commons/e/ec/Greater_Cairo_location_map.svg"
                    alt="Map Background"
                    className="w-full h-full object-cover"
                />
            </div>

            <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8 text-center">
                <div className="bg-white/90 backdrop-blur-md inline-block p-6 rounded-2xl shadow-xl">
                    <div className="w-12 h-12 bg-primary/10 text-primary rounded-full flex items-center justify-center mx-auto mb-4">
                        <Map className="w-6 h-6" />
                    </div>

                    <h2 className="text-2xl font-bold text-slate-900 mb-2">
                        {t('explore.map.title', 'Explore Interactive Map')}
                    </h2>
                    <p className="text-slate-500 text-sm max-w-xs mx-auto mb-6">
                        {t('explore.map.subtitle', 'Visualize the location of our projects and find the perfect spot for your investment.')}
                    </p>

                    <Link to="/projects" className="inline-flex bg-primary text-white px-6 py-2.5 rounded-lg text-sm font-bold shadow-lg hover:bg-primary/90 transition-colors items-center gap-2 mx-auto">
                        <MapPin className="w-4 h-4" />
                        {t('explore.map.cta', 'Open Map View')}
                    </Link>
                </div>
            </div>
        </section>
    );
};
